import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { applicationPaths } from '../../../Models/configurations';
import { UtilityServices } from './../../../Services/utility.services';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  //styleUrls: ['./cookie-policy.component.css']
})
export class CookiePolicyComponent implements OnInit {
  urlName: string;
  currentUrl:string;
  cookieInformation: string;
  
  constructor(
    private readonly utilityService: UtilityServices,
    private translate: TranslateService
  ) {
    this.urlName = '/' + applicationPaths.login;
    this.cookieInformation =this.translate.instant("lblCookieInformation");  
  }


  public redirectToHome() {
    this.moveNext();
  }

  public moveNext(): void {
    if(this.currentUrl)
      this.urlName='/' + this.currentUrl;
    this.utilityService.navigateToNext(this.urlName);
  }

  ngOnInit(): void {
    this.currentUrl=localStorage.getItem('currentUrl')
    this.currentUrl= this.currentUrl.split('/')[3];
  }

}
